import { render, staticRenderFns } from "./DocumentOverview.vue?vue&type=template&id=40319cdd&scoped=true&"
import script from "./DocumentOverview.vue?vue&type=script&lang=js&"
export * from "./DocumentOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40319cdd",
  null
  
)

export default component.exports